/* Ivevar: options popup - red alert on options the customer has not selected yet */
(function () {
  if (window.__ivvAlert) return;
  window.__ivvAlert = true;

  var css =
    '.ivv-go.ivv-wait{opacity:.55}' +
    '.ivv-opt.ivv-miss .ivv-optrow b,.ivv-opt.ivv-miss .ivv-optrow b em{color:#d0021b!important}' +
    '.ivv-opt.ivv-miss .ivv-v{border-color:#e5484d!important;background:#fff5f5!important}' +
    '.ivv-req{display:none;color:#d0021b;font-size:12px;font-weight:600;margin-top:6px}' +
    '.ivv-opt.ivv-miss .ivv-req{display:block}' +
    '.ivv-opt.ivv-shake{animation:ivvShake .4s}' +
    '.ivv-err{font-weight:600}' +
    '@keyframes ivvShake{0%,100%{transform:translateX(0)}20%,60%{transform:translateX(-6px)}40%,80%{transform:translateX(6px)}}';
  var st = document.createElement('style');
  st.textContent = css;
  document.head.appendChild(st);

  function label(opt) {
    var b = opt.querySelector('.ivv-optrow b');
    var t = b ? b.firstChild && b.firstChild.nodeValue || '' : '';
    t = t.replace(/:\s*$/, '').trim();
    if (/ring size/i.test(t)) return 'ring size';
    return t.toLowerCase();
  }
  function isMissing(opt) {
    var em = opt.querySelector('[data-chosen]');
    return !!em && em.textContent.trim() === 'Select';
  }
  function missingOpts(modal) {
    return Array.prototype.filter.call(modal.querySelectorAll('.ivv-opt'), isMissing);
  }

  // Keep the button tappable while options are missing (it shows the red alert instead)
  function syncButton(modal) {
    var go = modal.querySelector('.ivv-go');
    if (!go) return;
    var waiting = /^select\b/i.test(go.textContent.trim());
    if (waiting) {
      if (go.disabled) go.disabled = false;
      go.classList.add('ivv-wait');
    } else {
      go.classList.remove('ivv-wait');
    }
    if (modal.__ivvTried) {
      var miss = missingOpts(modal);
      modal.querySelectorAll('.ivv-opt').forEach(function (o) { o.classList.toggle('ivv-miss', miss.indexOf(o) > -1); });
      var err = modal.querySelector('.ivv-err');
      if (err && miss.length) {
        var msg = 'Please select ' + miss.map(label).join(', ') + ' to continue';
        if (err.textContent !== msg) err.textContent = msg;
        err.hidden = false;
      } else if (err && /^Please select/.test(err.textContent)) {
        err.hidden = true;
      }
    }
  }

  function setup(modal) {
    if (modal.__ivvAlert) return;
    modal.__ivvAlert = true;
    modal.querySelectorAll('.ivv-opt').forEach(function (o) {
      if (o.querySelector('.ivv-req')) return;
      var r = document.createElement('div');
      r.className = 'ivv-req';
      r.textContent = 'Please select ' + label(o);
      o.appendChild(r);
    });
    syncButton(modal);
    var busy = false;
    new MutationObserver(function () {
      if (busy) return;
      busy = true;
      syncButton(modal);
      busy = false;
    }).observe(modal, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled'] });
  }

  new MutationObserver(function () {
    var m = document.querySelector('.ivv-modal');
    if (m) setup(m);
  }).observe(document.body, { childList: true });

  // Tap on "Select ..." button: highlight every missing option in red
  window.addEventListener('click', function (e) {
    var go = e.target.closest && e.target.closest('.ivv-go');
    if (!go) return;
    var modal = go.closest('.ivv-modal');
    if (!modal) return;
    var miss = missingOpts(modal);
    if (!miss.length) return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    modal.__ivvTried = true;
    syncButton(modal);
    miss.forEach(function (o) { o.classList.remove('ivv-shake'); void o.offsetWidth; o.classList.add('ivv-shake'); });
    miss[0].scrollIntoView({ block: 'center', behavior: 'smooth' });
  }, true);
})();
